<template>
  <q-item
    dense
    class="q-pr-sm upload-file-container"
    :class="{'invisible-item': invisible, 'bg-red-1': !!error, 'bg-grey-1' : !error && !invisible, 'q-pl-xs': !withoutPreview, 'q-pl-sm': withoutPreview}"
    :clickable="clickable"
    @click="$emit('details')"
  >
    <q-item-section
      v-if="!withoutPreview"
      avatar
      side
      class="q-pr-sm"
    >
      <q-avatar
        rounded
        :size="previewHeightPx"
        :class="{'shadow-1 bg-grey-11 cursor-pointer': clickableSide}"
        @click.stop="clickableSide || clickable ? $emit('details') : null"
      >
        <div>
          <q-icon
            v-if="file.type !== 'IMAGE'"
            size="1.1em"
            :name="getIcon(file.file_extension)"
          />
          <img
            v-else
            class="checkerboard shadow-2"
            style="max-width: 100%; max-height: 100%; width: auto; height: auto;"
            :src="getNextAvailableImage(file)"
          />
        </div>
        <q-tooltip v-if="clickableSide">
          View File
        </q-tooltip>
      </q-avatar>
    </q-item-section>

    <q-item-section class="q-py-xs">
      <q-item-label
        v-if="!withoutTitle && !!file.title"
        :title="file.title"
        class="text-caption text-bold"
      >
        {{ truncateString(file.title, 40) }}
      </q-item-label>
      <q-item-label
        :title="file.file_name"
        caption
        class="break-word"
      >
        {{ truncateString(file.file_name, 30) }}
      </q-item-label>
      <q-item-label caption>
        {{ getFilesize(file.total_file_size) }}
      </q-item-label>
      <q-item-label v-if="!!error" class="text-red-7 q-my-xs text-bold">
        {{ error }}
      </q-item-label>
    </q-item-section>

    <q-item-section
      v-if="!readOnly"
      side
      @click.stop
    >
      <cancel-button
        label="Remove"
        @click="$emit('remove')"
      />
    </q-item-section>
  </q-item>
</template>

<script>
import fileMixin from '../../mixins/fileMixin'

export default {
  mixins: [fileMixin],
  props: {
    file: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    clickableSide: {
      type: Boolean,
      default: false
    },
    error: {
      type: String
    },
    // Extreme condensed mode
    invisible: {
      type: Boolean,
      default: false
    },
    // Hide file preview
    withoutPreview: {
      type: Boolean,
      default: false
    },
    // Hide title if exists
    withoutTitle: {
      type: Boolean,
      default: false
    },
    // Size of avatar preview (px)
    previewHeight: {
      type: Number
    }
  },
  emits: ['details', 'remove'],
  computed: {
    previewHeightPx () {
      let val = this.previewHeight
      if (!val && this.windowWidth < 768) {
        val = 40
      }

      if (!val) {
        val = 75
      }

      return val + 'px'
    }
  }
}
</script>
